import { render, staticRenderFns } from "./CrmBoardUi.vue?vue&type=template&id=34d6ba0d&scoped=true&lang=pug&"
import script from "./CrmBoardUi.vue?vue&type=script&lang=js&"
export * from "./CrmBoardUi.vue?vue&type=script&lang=js&"
import style0 from "./CrmBoardUi.vue?vue&type=style&index=0&id=34d6ba0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d6ba0d",
  null
  
)

export default component.exports